import type React from 'react';

import { Drawer } from 'ui-components/components/drawer/drawer';

import style from './drawer-layout.module.css';

type ProductDetailsDrawerLayoutProps = {
  children: React.ReactNode;
  onClose: () => void;
};

export const ProductDetailsDrawerLayout = ({ children, onClose }: ProductDetailsDrawerLayoutProps) => (
  <Drawer canvasClassName={style.canvas} className={style.drawer} onCancel={onClose} onClose={onClose} shouldNotUsePortal>
    {children}
  </Drawer>
);
